import React from 'react';
import styled from 'styled-components';
import { IconName } from '@nauto/uikit/dist/atoms/icons';
import { withClickOutside } from '@nauto/uikit/dist/utils/click-outside';
import ControlBarButton from './control-bar-button';
import { colors } from '@nauto/uikit/dist/styles';

export interface Props {
  icon: IconName;
  className?: string;
  disabled?: boolean;
  label: string;
  children: any;
  color: string;
}

export interface State {
  isOpen: boolean;
}

export class ControlBarDropdown extends React.Component<Props, State> {
  state = { isOpen: false };
  private drawerEl = null;

  handleToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  public handleClickOutside = e => {
    // make sure we're not clicking inside the abs positioned div
    if (!this.drawerEl || this.drawerEl.contains(e.target)) {
      return;
    }
    this.setState({ isOpen: false });
  };

  public render() {
    const { className, disabled, icon, label, color, children } = this.props;
    const { isOpen } = this.state;
    return (
      <div className={className}>
        <ControlBarButton
          {...{ icon, label, disabled, color }}
          onClick={this.handleToggle}
        />
        {isOpen && (
          <div className="drawer" ref={el => (this.drawerEl = el)}>
            {React.Children.map(children, child =>
              React.cloneElement(child, {
                handleToggle: this.handleToggle,
              }),
            )}
          </div>
        )}
      </div>
    );
  }
}
const WrappedControlBarDropdown = withClickOutside(ControlBarDropdown);

export default styled(WrappedControlBarDropdown)`
  position: relative;
  .drawer {
    z-index: 1;
    position: absolute;
    top: 100%;
    background: white;
    max-height: 25rem;
    background: white;
    overflow-y: auto;
    box-shadow: 0px 2px 4px 0px ${colors.grey500};
  }
`;
